import React from 'react';
import './Why.css';

const Why = () => {
  const points = [
    {
      icon: '⚡',
      title: 'سرعت NVMe واقعی',
      desc: 'سرورهای NVMe با I/O بالا — نه SSD معمولی',
    },
    {
      icon: '🛡️',
      title: 'امنیت پیشرفته',
      desc: 'DDoS Protection، فایروال و SSL رایگان روی همه پلن‌ها',
    },
    {
      icon: '💬',
      title: 'پشتیبانی فارسی ۲۴/۷',
      desc: 'تیکت، تلگرام و تلفن — هر وقت مشکل داشتید',
    },
    {
      icon: '🔑',
      title: 'کنترل کامل',
      desc: 'Root access کامل — بدون محدودیت روی سرورهای شما',
    },
  ];

  return (
    <section className="why" id="why">
      <div className="wrap">
        <div className="why-grid">
          <div>
            <span className="sec-tag">چرا افراسل</span>
            <h2 className="sec-h">زیرساختی که<br />به آن تکیه می‌کنید</h2>
            <p className="sec-p">می‌دانیم کسب‌وکار ایرانی چه نیاز دارد. سرعت، پایداری، پشتیبانی فارسی — بدون پیچیدگی.</p>
            <div className="why-points">
              {points.map((p, i) => (
                <div key={i} className="wpt">
                  <div className="wpt-ico">{p.icon}</div>
                  <div>
                    <div className="wpt-h">{p.title}</div>
                    <div className="wpt-p">{p.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="why-right">
            <div className="metric-card">
              <div className="metric-big">۹۹.۹٪</div>
              <div className="metric-label">آپتایم سالانه تضمینی — SLA مکتوب</div>
            </div>
            <div className="dc-row">
              <h4>دیتاسنترهای فعال</h4>
              <div className="dc-item"><span className="dc-dot"></span>تهران، ایران</div>
              <div className="dc-item"><span className="dc-dot"></span>آمستردام، هلند</div>
            </div>
            <div className="metric-card" style={{ background: 'var(--orange-dim)', borderColor: 'rgba(249,115,22,.2)' }}>
              <div className="metric-big" style={{ color: 'var(--orange)' }}>۵۰۰+</div>
              <div className="metric-label">مشتری فعال در ایران و خارج از کشور</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why;
